import React, { useEffect, useRef, useState } from 'react'
import iiIcon from '../../../assets/corporate/ii.png'
import otrIcon from '../../../assets/corporate/otr.png'
import fbIcon from '../../../assets/corporate/fb.png'
import etemIcon from '../../../assets/corporate/etem.png'
import csIcon from '../../../assets/corporate/cs.png'
import suppIcon from '../../../assets/corporate/supp.png'
import './WhyChooseUs.scss'

const WhyChooseUs = () => {
    const [visibleCards, setVisibleCards] = useState(new Set())
    const sectionRef = useRef(null)

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const cardIndex = parseInt(entry.target.dataset.cardIndex)
                        setTimeout(() => {
                            setVisibleCards((prev) => new Set(prev).add(cardIndex))
                        }, cardIndex * 100) // Staggered animation
                    }
                })
            },
            { threshold: 0.1 }
        )

        const cards = sectionRef.current?.querySelectorAll('.why-choose-us__card')
        cards?.forEach((card) => observer.observe(card))

        return () => observer.disconnect()
    }, [])

    const handleCardClick = (index, title) => {
        // Add click interaction if needed
        console.log(`Clicked on ${title}`)
    }
    return (
        <section className='why-choose-us mt-8' ref={sectionRef}>
            <div className='why-choose-us__container'>
                <h2 className='why-choose-us__heading'>Why Choose Us</h2>
                <div className='why-choose-us__grid'>
                    <div 
                        className={`why-choose-us__card ${visibleCards.has(0) ? 'animate-in' : ''}`}
                        data-card-index={0}
                        onClick={() => handleCardClick(0, 'Instant Invoicing')}
                    >
                        <div className='why-choose-us__icon-box'>
                            <img src={iiIcon} alt="Instant Invoicing" className='why-choose-us__icon' />
                        </div>
                        <h3 className='why-choose-us__title'>Instant Invoicing</h3>
                        <p className='why-choose-us__text'>
                            Quick quotes and clear invoices.
                        </p>
                    </div>
                    <div 
                        className={`why-choose-us__card ${visibleCards.has(1) ? 'animate-in' : ''}`}
                        data-card-index={1}
                        onClick={() => handleCardClick(1, 'On-Time Rides')}
                    >
                        <div className='why-choose-us__icon-box'>
                            <img src={otrIcon} alt="On-Time Rides" className='why-choose-us__icon' />
                        </div>
                        <h3 className='why-choose-us__title'>On-Time Rides</h3>
                        <p className='why-choose-us__text'>
                            Reliable pick-up and drop-off.
                        </p>
                    </div>
                    <div 
                        className={`why-choose-us__card ${visibleCards.has(2) ? 'animate-in' : ''}`}
                        data-card-index={2}
                        onClick={() => handleCardClick(2, 'Flexible Booking')}
                    >
                        <div className='why-choose-us__icon-box'>
                            <img src={fbIcon} alt="Flexible Booking" className='why-choose-us__icon' />
                        </div>
                        <h3 className='why-choose-us__title'>Flexible Booking</h3>
                        <p className='why-choose-us__text'>
                            Book anytime, any vehicle.
                        </p>
                    </div>
                    <div 
                        className={`why-choose-us__card ${visibleCards.has(3) ? 'animate-in' : ''}`}
                        data-card-index={3}
                        onClick={() => handleCardClick(3, 'End-to-End Management')}
                    >
                        <div className='why-choose-us__icon-box'>
                            <img src={etemIcon} alt="End-to-End Management" className='why-choose-us__icon' />
                        </div>
                        <h3 className='why-choose-us__title'>End-to-End Management</h3>
                        <p className='why-choose-us__text'>
                            From booking to billing.
                        </p>
                    </div>
                    <div 
                        className={`why-choose-us__card ${visibleCards.has(4) ? 'animate-in' : ''}`}
                        data-card-index={4}
                        onClick={() => handleCardClick(4, 'Customisable Service')}
                    >
                        <div className='why-choose-us__icon-box'>
                            <img src={csIcon} alt="Customisable Service" className='why-choose-us__icon' />
                        </div>
                        <h3 className='why-choose-us__title'>Customisable Service</h3>
                        <p className='why-choose-us__text'>
                            Tailored to your needs.
                        </p>
                    </div>
                    <div 
                        className={`why-choose-us__card ${visibleCards.has(5) ? 'animate-in' : ''}`}
                        data-card-index={5}
                        onClick={() => handleCardClick(5, '24/7 Support')}
                    >
                        <div className='why-choose-us__icon-box'>
                            <img src={suppIcon} alt="24/7 Support" className='why-choose-us__icon' />
                        </div>
                        <h3 className='why-choose-us__title'>24/7 Support</h3>
                        <p className='why-choose-us__text'>
                            Always available.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WhyChooseUs

